// OpenType Specification
// https://docs.microsoft.com/en-us/typography/opentype/spec/os2#usweightclass

export enum EFontWeight {
    ExtraLight = 200,
    Light = 300,
    Normal = 400,
    Medium = 500,
    SemiBold = 600,
    Bold = 700
}

export enum EFonts {
    Hatton = 'Hatton, serif',
    Montserrat = 'Montserrat, sans-serif'
}

export enum EColors {
    NaturalBlack = '#000',
    White = '#FFF',
    Gold = '#A78E52',
    GoldenSand = '#B9A55C',
    SpringWood = '#F0EEE4',
    Cameo = '#DBBEA8',
    GoldenLight = '#EAE2D7',
    LightOatmeal = '#FAF6ED',
    SilverChalice = '#a9a9a9',
    Alabaster = '#fbfbfb',
    SilverChalicer = '#aaaaaa',
    DoveGrey = '#707070',
    WildSand = '#f6f6f6',
    SwissCoffee = '#d2cdcd',
    //
    OuronyxLogo = '#ECE2D6',
    DisabledTile = '#D9D4D0',
    DarkOatmeal = '#E4DBCF',
    LightPanel = '#F4EEE7',
    DarkRed = '#8B0000',
    //
    ArchetypeRed = '#b80f0f',
    ArchetypeGreen = '#24897a',
    ArchetypeBlue = '#28247f',
    ArchetypeYellow = '#ffca00'
}

export enum EBreakpoints {
    ExtraSmall = 320,
    Small = 768,
    Medium = 1024,
    Large = 1280,
    ExtraLarge = 1920
}

export enum ETimes {
    MenuAnimationTime = 900
}

export enum ESizes {
    NavbarHeight = 65,
    GutterXS = 28,
    GutterS = 35,
    GutterM = 75
}

export enum EClinikoEndpoint {
    Patients = 'patients/{patientId}'
}

export enum EApiEndpoint {
    AppointmentBookingRequest = 'appointment_booking_request/',
    AppointmentBookingRequestAppointmentTime = 'appointment_booking_request/appointment_time/clinic/{clinicId}/appointment_type/{appointmentTypeId}',
    AppointmentNoShowCharge = 'appointment_no_show/charge',
    VirtualAppointment = 'cliniko/virtual_appointment/',
    ListClinic = 'cliniko/clinic/',
    AppointmentType = 'cliniko/appointment_type/{clinicId}',
    AppointmentTimesByClinic = 'cliniko/appointment_time/clinic/{clinicId}/appointment_type/{appointmentTypeId}/{date}',
    AppointmentTimesByPractitioner = 'cliniko/appointment_time/clinic/{clinicId}/practitioner/{practitionerId}/appointment_type/{appointmentTypeId}/{date}',
    AppointmentValidate = 'cliniko/appointment_time/validate/clinic/{clinicId}/appointment_type/{appointmentTypeId}/{startsAt}',
    ClinicById = 'cliniko/clinic/{clinicId}',
    DoctorsByClinic = 'cliniko/clinic/{clinicId}/practitioners',
    PractitionerByAppointmentAndTime = 'cliniko/clinic/{clinicId}/practitioners/appointment_type/{appointmentTypeId}/startsAt/{startsAt}',
    ClinicsByDoctor = 'cliniko/practitioners/{id}/clinics',
    ClinicRestrictedDates = 'cliniko/restricted_dates/{clinicId}',
    ClinicDashboardAppointments = 'clinic_dashboard/{clinicId}/appointments',
    User = 'user',
    GetBillable = 'checkout/billable/{clinicId}/{appointmentTypeId}',
    PostCart = 'checkout/cart',
    CheckoutMethods = 'checkout/methods',
    CheckoutPaymentsDetails = 'checkout/payments/details',
    CheckoutCartAddress = 'checkout/cart/address',
    CheckoutPayment = 'checkout/payment',
    CheckoutPlaceOrder = 'checkout/placeOrder',
    Doctors = 'cliniko/practitioners',
    UserLogin = 'login',
    StaffLogin = 'staff_login',
    UserLoginCheck = 'login_check',
    UserLoginCode = 'login_passcode',
    UserPasswordResetRequest = 'user/password_reset/request',
    UserPasswordReset = 'user/password_reset/reset',
    UserPassword = 'user/password',
    TwoFactorAuthCheck = '2fa_check',
    LoyaltyPoints = 'loyalty/points/{patientId}',
    LoyaltyPointsHistory = 'loyalty/points/history/{patientId}',
    LoyaltyReward = 'loyalty/reward/{patientId}',
    LoyaltyReferralTypes = 'loyalty/referral/source_type/{clinicId}',
    LoyaltyReferralReferee = 'loyalty/referral/{patientId}/referee',
    LoyaltyReferralPost = 'loyalty/referral/{typeId}/{patientId}/{refereeId}',
    LoyaltyReviewPost = 'loyalty/review/{patientId}',
    LoyaltyRedeem = 'loyalty/redeem/{patientId}/{invoiceId}/{rewardId}/{amount}',
    Patient = 'patient',
    PatientProfile = 'patient_profile/{patientId}',
    PatientAppointments = 'patient/appointments',
    PatientPractitioner = 'patient/practitioner',
    PatientClinic = 'patient/clinic',
    PatientTreatmentplan = 'patient/treatmentplan',
    PatientPersonalityArchetype = 'patient/psych_attr/personality_archetype',
    PatientImageUrl = 'patient/photo',
    PatientInvoices = 'patient/invoices',
    PractitionerFirstConsultation = 'practitioner/appointment/first',
    Practitioner = 'practitioner/',
    PractitionerAppointment = 'practitioner/appointment',
    PractitionerPsychologicalAttributes = 'practitioner/psych_attr_survey_response/{patientId}',
    PractitionerPsychologicalResetSkip = 'practitioner/psych_attr_survey_response/{patientId}/reset_skip',
    PractitionerRevenue = 'practitioner/revenue/{startDate}/{endDate}',
    PractitionerInvoices = 'practitioner/invoices/{startDate}/{endDate}',
    PractitionerFeedback = 'practitioner/feedback',
    PractitionerInstance = 'practitioner/instance',
    PatientAppointmentsCancel = 'patient/{clinicId}/appointments/{id}/cancel',
    PatientAppointmentsById = 'patient/{clinicId}/appointments/{id}',
    PsychologicalSurvey = 'psych_attr_survey/',
    PsychologicalArchetype = 'psych_attr_archetype/{respondentId}',
    PsychologicalSurveyById = 'psych_attr_survey/{surveyId}',
    PsychologicalSurveyCheckRespondent = 'psych_attr_survey/check_respondent/{surveyId}',
    PsychologicalSurveyDecline = 'psych_attr_survey/decline/{surveyId}',
    PsychologicalSurveyDeclineScoped = 'psych_attr_survey/decline_scoped/{surveyId}',
    ReceptionPatient = 'reception/{clinicId}/patient',
    ReceptionRefreshments = 'reception/patient/{patientId}/refreshments',
    ReceptionMakeup = 'reception/patient/{patientId}/makeup',
    ReceptionReferral = 'reception/patient/{clinicId}/{patientId}/referral_source',
    ReceptionAppointmentAttendance = 'reception/{clinicId}/appointment/{appointmentId}/attendance',
    ClinicAttendanceUpdate = 'clinic_attendance/appointment_state',
    ClinicAttendance = 'clinic_attendance/appointment_state/{appointmentId}',
    AftercareTemplate = 'aftercare_template/{patientId}/{appointmentId}',
    InvoicePatient = 'invoice/patient/{clinicId}/{patientId}/{invoiceId}',
    InvoiceAppointment = 'invoice/appointment/{clinicId}/{appointmentId}',
    TreatmentPlanGoals = 'treatmentplan/goals',
    TreatmentPlanPlan = 'treatmentplan/plan/{patientId}',
    TreatmentPlanPlanTransfer = 'treatmentplan/plan/{patientId}/transfer',
    TreatmentPlanPlanDelete = 'treatmentplan/plan/{patientId}/{planId}',
    TreatmentPlanPlanArchive = 'treatmentplan/plan/{patientId}/{planId}/archive',
    BaristaGetRefreshments = 'barista/refreshments/{clinicId}',
    BaristaAcknowledgeRefreshments = 'barista/refreshments/{id}',
    TreatmentConsent = 'treatment_consent/{patientId}',
    ShareConsent = 'data_sharing/consent',
    ShareConsentGet = 'data_sharing/consent/{patientId}',
    TreatmentZone = 'treatment/zone/',
    TreatmentGoal = 'treatment/goal/{area}',
    TreatmentArea = 'treatment/area/',
    TreatmentNote = 'treatment/note',
    TreatmentNotePatch = 'treatment/note/{noteId}',
    TreatmentNoteFinalise = 'treatment/note/{noteId}/finalise',
    TreatmentNoteSaveAndFinalise = 'treatment/note/{noteId}/save-and-finalise',
    TreatmentNoteConsumables = 'treatment/note/consumables/{clinicId}',
    TreatmentNoteTrackedVolume = 'treatment/note/tracked/volume/{clinicId}/{barcode}',
    TreatmentAppointmentSummary = 'treatment/appointment_summary/{clinicId}/{appointmentId}/',
    TreatmentNoteOutcome = 'treatment_note/outcome',
    TreatmentObservationsPatch = 'treatment/observation/{id}',
    TreatmentObservations = 'treatment/observation/',
    TreatmentObservationsGet = 'treatment/observation/{clinicId}/{appointmentId}',
    TreatmentAesthetician = 'facial_aesthetician/treatment/note',
    TreatmentAestheticianGet = 'facial_aesthetician/treatment/note/{patientId}/{appointmentId}',
    DearProducts = 'dear/product/{clinicId}',
    DearProduct = 'dear/product/{clinicId}/{barcode}',
    DearReasons = 'dear/damaged_reason',
    DearProductDamaged = 'dear/damaged',
    DearProductDamagedByPractitioner = 'dear/damaged/{practitionerId}',
    StripeUserIntent = 'stripe/user/intent',
    StripeUserMethods = 'stripe/user/methods',
    StripeUserMethod = 'stripe/user/methods/{id}',
    GeoipCountry = 'geoip/country',
    ClinicConfig = 'config/{path}/{clinicId}',
    Config = 'config/',
    NewsletterSubscribe = 'newsletter/subscribe/{email}',
    FormsContactUs = 'forms/contact_us/',
    FormsPractitionerFeedback = 'forms/practitioner_feedback/',
    FilesGetList = 'patient_files/list/{patientId}',
    FilesPost = 'patient_files/upload/{patientId}',
    FilesPrepareUpload = 'patient_files/prepare_upload/{patientId}',
    FilesConfirmUpload = 'patient_files/confirm_upload/{patientId}',
    FilesPatch = 'patient_files/{patientId}/{patientFileId}',
    FilesDownloadToken = 'patient_files/{patientId}/{patientFileId}',
    FilesGetLinks = 'patient_files/{patientId}/{patientFileId}/links',
    FilesGetDownload = 'patient_files/download/{downloadToken}',
    UploadedFilesGetBuckets = 'uploaded_files/buckets',
    MedicalFormSubmit = 'medical_form/',
    MedicalFormGet = 'medical_form/{patientId}',
    MedicalFormPrefill = 'medical_form/prefill/{patientId}',
    MedicalFormHistory = 'medical_form/history/{patientId}',
    MedicalFormGetById = 'medical_form/submission/{submissionId}',
    MedicalFormCorrect = 'medical_form/correction/{patientId}',
    SkinGradesPost = 'skin_grades/',
    SkinGradesGet = 'skin_grades/{patientId}',
    BalanceProgrammeActivate = 'balance_programme/{patientId}/activate',
    BalanceProgramme = 'balance_programme/{patientId}',
    BalanceProgrammeDeactivate = 'balance_programme/{patientId}/deactivate',
    ClinicianNotesPost = 'balance_clinician_notes/',
    ClinicianNotesGet = 'balance_clinician_notes/{patientId}',
    RecallCases = 'recall_cases',
    RecallCase = 'recall_cases/{caseId}',
    RecallCaseAction = 'recall_cases/{caseId}/{action}',
    RecallCaseRefresh = 'recall_cases/{caseId}/refresh',
    RecallReportSummary = 'recall_cases/reports/summary',
    RecallReportChannels = 'recall_cases/reports/channels',
    RecallExceptions = 'recall_cases/exceptions',
    RecallAutomationExecutions = 'recall_cases/automation-executions',
    RecallTypes = 'recall_types',
    RecallType = 'recall_types/{recallTypeId}'
}

export enum ERoutes {
    Home = '/',
    AdvisoryPanel = '/advisory-panel/',
    CallBack = '/call-back/',
    Virtual = '/virtual/',
    Conversation = '/conversation/',
    Journey = '/journey/',
    Contact = '/contact/',
    OurStory = '/our-story/',
    Doctors = '/doctors/',
    Experience = '/experience/',
    Services = '/services/',
    Appointment = '/appointment/',
    PanelHome = '/panel/',
    PanelStaffLogin = '/panel/staff/login',
    PanelCustomerLogin = '/panel/customer/login',
    PanelStaffPin = '/panel/staff/pin',
    PanelStaffDashboard = '/panel/staff/dashboard',
    PanelStaffDashboardPatient = '/panel/staff/dashboard/patient',
    PanelStaffDashboardPatientById = '/panel/staff/dashboard/patient/{patientId}',
    PanelStaffDashboardPatientSearch = '/panel/staff/dashboard/patient-search',
    PanelStaffDashboardNoShow = '/panel/staff/dashboard/no-show',
    PanelStaffDashboardFileUpload = '/panel/staff/dashboard/patient-file-upload/{patientId}',
    PanelStaffDashboardFileEdit = '/panel/staff/dashboard/patient-file-edit/{patientId}/{patientFileId}',
    PanelStaffDashboardPsychologicalAttributes = '/panel/staff/dashboard/psychological-attributes/{patientId}',
    PanelStaffDashboardRefreshments = '/panel/staff/dashboard/refreshments',
    PanelStaffDashboardMessages = '/panel/staff/dashboard/messages',
    PanelStaffDashboardFeedback = '/panel/staff/dashboard/feedback',
    PanelStaffDashboardCreateEditTreatmentPlan = '/panel/staff/dashboard/create-edit-treatment-plan',
    PanelStaffDashboardViewTreatmentPlans = '/panel/staff/dashboard/treatment-plans/{patientId}',
    PanelStaffDashboardShareConsent = '/panel/staff/dashboard/share-consent/{patientId}',
    PanelStaffDashboardViewTreatmentObservations = '/panel/staff/dashboard/treatment-observations/{patientId}',
    PanelStaffDashboardViewAestheticianTreatment = '/panel/staff/dashboard/treatment-aesthetician/{patientId}',
    PanelStaffDashboardTreatmentNotes = '/panel/staff/dashboard/treatment-notes/',
    PanelStaffDashboardLoyaltyEarn = '/panel/staff/dashboard/loyalty-earn/{patientId}',
    PanelStaffDashboardLoyaltyReview = '/panel/staff/dashboard/loyalty-review/{patientId}',
    PanelStaffDashboardLoyaltyRedeem = '/panel/staff/dashboard/loyalty-redeem/{patientId}',
    PanelStaffDashboardMedicalFormView = '/panel/staff/dashboard/medical-form-view/{patientId}',
    PanelStaffDashboardMedicalFormEdit = '/panel/staff/dashboard/medical-form-edit/{patientId}',
    PanelStaffDashboardSkinGrades = '/panel/staff/dashboard/skin-grades/{patientId}',
    PanelStaffDashboardBalanceProgramme = '/panel/staff/dashboard/balance-programme/{patientId}',
    PanelStaffDashboardClinicianNotes = '/panel/staff/dashboard/clinician-notes/{patientId}',
    PanelStaffDashboardBalance = '/panel/staff/dashboard/balance',
    PanelStaffDashboardBalancePatient = '/panel/staff/dashboard/balance/{contextId}',
    PanelStaffDashboardRecalls = '/panel/staff/dashboard/recalls',
    PanelStaffDashboardRecallCase = '/panel/staff/dashboard/recalls/case/{caseId}',
    PanelStaffDashboardRecallReporting = '/panel/staff/dashboard/recalls/reporting',
    PanelStaffDashboardRecallReview = '/panel/staff/dashboard/recalls/review',
    PanelBaristaRefreshmentsList = '/panel/staff/dashboard/barista-refreshments-list',
    PanelStaffDashboardDamagedProducts = '/panel/staff/dashboard/damaged-products',
    PanelCustomerDashboard = '/panel/customer/dashboard',
    PanelCustomerDashboardDetails = '/panel/customer/dashboard/details/{patientId}',
    PanelCustomerDashboardSavedPaymentDetails = '/panel/customer/dashboard/saved-payment-details',
    PanelCustomerDashboardCommunicationPrefs = '/panel/customer/dashboard/communication-preferences',
    PanelCustomerDashboardPersonalityArchetype = '/panel/customer/dashboard/personality-archetype',
    PanelCustomerDashboardMyJourney = '/panel/customer/dashboard/my-journey',
    PanelCustomerDashboardPastAppointments = '/panel/customer/dashboard/past-appointments',
    PanelCustomerDashboardUpcomingAppointments = '/panel/customer/dashboard/upcoming-appointments',
    PanelCustomerDashboardMyTreatmentPlan = '/panel/customer/dashboard/my-treatment-plan',
    PanelCustomerDashboardMyFiles = '/panel/customer/dashboard/my-files',
    PanelCustomerDashboardMyInvoices = '/panel/customer/dashboard/my-invoices',
    PanelCustomerDashboardLoyaltyArea = '/panel/customer/dashboard/loyalty-area',
    PanelWelcomeInternal = '/panel/welcome-internal',
    ArchetypesSurvey = '/survey/',
    ArchetypeRed = '/red/',
    ArchetypeGreen = '/green/',
    ArchetypeYellow = '/yellow/',
    ArchetypeBlue = '/blue/',
    Book = '/book/'
}

export enum ERoles {
    Practitioner = 'ROLE_PRACTITIONER',
    Receptionist = 'ROLE_RECEPTIONIST',
    Barista = 'ROLE_BARISTA',
    Nurse = 'ROLE_NURSE',
    MakeupArtist = 'ROLE_MAKEUP_ARTIST',
    SkincareConsultant = 'ROLE_SKINCARE_CONSULTANT',
    Administrator = 'ROLE_ADMINISTRATOR',
    ClientAdvisor = 'ROLE_CLIENT_ADVISOR'
}

/**
 * Not an enum but in this file so it's
 * obvious to update if new ERoles are added
 */
export const AdminRoles = [
    ERoles.Practitioner,
    ERoles.Receptionist,
    ERoles.Nurse,
    ERoles.Barista,
    ERoles.MakeupArtist,
    ERoles.SkincareConsultant,
    ERoles.Administrator,
    ERoles.ClientAdvisor
];

export enum ETreatmentNoteStatus {
    Draft = 'draft',
    Final = 'final',
    Locked = 'locked'
}

export enum ERefreshmentStatus {
    Pending = 1,
    Completed = 0
}

export enum EAppointmentStatePlaces {
    AwaitingArrival = 'awaiting_arrival',
    Arrived = 'arrived',
    Late = 'late',
    NoShow = 'no_show_cancelled',
    InOnboarding = 'in_onboarding',
    ReadyForCleanseImaging = 'ready_for_cleanse_imaging',
    InCleanseImaging = 'in_cleanse_imaging',
    InNumbing = 'in_numbing',
    InAppointment = 'in_appointment',
    ReadyForMakeup = 'ready_for_makeup',
    ReadyForExit = 'ready_for_exit',
    FollowOnTreatment = 'follow_on_treatment',
    Exited = 'exited',
    Aftercare = 'aftercare'
}
